import SubHeader from '../helpers/SubHeader.tsx';
import { NCard } from 'nayan';

const TermsOfUse = () => {
  return (
    <div className="p-3">
      <SubHeader title="Terms of Use" />
      <NCard className="p-3 mt-3">
        <p className="mt-2">
          Welcome to <span className="font-semibold">Kidster</span>! These Terms of Use (“Terms”) constitute a legally binding agreement between you
          (the parent or legal guardian) and Kidster regarding your access to and use of our application and related services. By downloading,
          accessing, or using Kidster, you confirm that you have read, understood, and agree to be bound by these Terms. If you do not agree with any
          provision of these Terms, you must not use the app.
        </p>

        <h3 className="text-xl mt-6">1. Eligibility and Parental Responsibility</h3>
        <p className="mt-2">
          Kidster is intended for children under the age of 13, and access to the application must be under the direct supervision and consent of a
          parent or legal guardian. The parent or guardian is solely responsible for monitoring and controlling the child’s activity and ensuring safe
          use in accordance with these Terms.
        </p>

        <h3 className="text-xl mt-6">2. User Accounts</h3>
        <p className="mt-2">
          Certain features of the app require account registration. By creating an account, you agree to provide accurate, complete, and current
          information. You are responsible for maintaining the confidentiality of your login credentials and for all activity that occurs under your
          account. Sharing login credentials or allowing unauthorized access is strictly prohibited.
        </p>

        <h3 className="text-xl mt-6">3. Data Protection and Privacy</h3>
        <p className="mt-2">
          Your use of Kidster is subject to our <strong>Privacy Policy</strong>. By using the app, you acknowledge and consent to the collection,
          processing, and use of data as described in our policy. Personal data is only collected with the informed consent of the parent or guardian
          and used strictly for the operation and improvement of the app.
        </p>

        <h3 className="text-xl mt-6">4. Subscription and Payments</h3>
        <p className="mt-2">
          Kidster may offer subscription-based features, including an ad-free experience and additional functionality. Payments are securely processed
          by third-party payment providers. By subscribing, you authorize the applicable charges and agree to the provider’s terms. All fees are
          non-refundable unless required by law.
        </p>

        <h3 className="text-xl mt-6">5. Advertisements and Third-Party Services</h3>
        <p className="mt-2">
          The app may display third-party advertisements unless a valid subscription is active. These ads may contain links or cookies governed by the
          advertiser’s privacy policies. We do not endorse or assume responsibility for third-party services, content, or conduct.
        </p>

        <h3 className="text-xl mt-6">6. Acceptable and Prohibited Use</h3>
        <p className="mt-2">
          You agree to use Kidster only for lawful purposes and in accordance with these Terms. Prohibited actions include, but are not limited to:
        </p>
        <ul className="list-disc list-inside mt-2 ml-4">
          <li>Accessing or using the app for any unlawful, fraudulent, or malicious purpose</li>
          <li>Attempting to probe, scan, or test the vulnerability of any system or network</li>
          <li>Reverse engineering, modifying, or tampering with the app’s code or structure</li>
          <li>Interfering with the app’s functionality, server integrity, or network security</li>
          <li>Uploading or transmitting malicious software or harmful content</li>
        </ul>

        <h3 className="text-xl mt-6">7. Connectivity and Device Responsibility</h3>
        <p className="mt-2">
          Kidster requires an active internet connection for optimal functionality. Users are responsible for ensuring their devices are properly
          maintained, secured, and compatible. Any data usage or connectivity charges are solely the responsibility of the user or guardian.
        </p>

        <h3 className="text-xl mt-6">8. Intellectual Property Rights</h3>
        <p className="mt-2">
          All intellectual property rights in and to the Kidster application, including but not limited to software, design, text, graphics, logos,
          audio, and video content, are owned or licensed by us. You are granted a limited, non-exclusive, non-transferable, revocable license to use
          the app solely for personal, non-commercial purposes. You may not reproduce, copy, modify, distribute, or exploit any part of the app
          without prior written permission.
        </p>

        <h3 className="text-xl mt-6">9. Disclaimers and Limitation of Liability</h3>
        <p className="mt-2">
          Kidster is provided “as is” and “as available,” without any warranties or representations, express or implied. To the maximum extent
          permitted by law, we disclaim any liability for:
        </p>
        <ul className="list-disc list-inside mt-2 ml-4">
          <li>Errors, bugs, or interruptions in the service</li>
          <li>Loss of data, revenue, or profits</li>
          <li>Unauthorized access or security breaches beyond our control</li>
        </ul>
        <p className="mt-2">
          Your use of the app is at your own risk. We are not liable for any damages arising out of or related to your use of the app, even if we have
          been advised of the possibility of such damages.
        </p>

        <h3 className="text-xl mt-6">10. Termination and Account Suspension</h3>
        <p className="mt-2">
          We reserve the right to suspend, restrict, or terminate access to Kidster without prior notice for any violation of these Terms, suspected
          fraud, abuse, or misconduct. Upon termination, your right to access and use the app will immediately cease. We may also delete any
          associated data in accordance with our data retention policy.
        </p>

        <h3 className="text-xl mt-6">11. Modifications to Terms</h3>
        <p className="mt-2">
          We may revise these Terms at any time, with changes becoming effective immediately upon posting. It is your responsibility to review the
          Terms periodically. Continued use of the app after updates implies acceptance of the modified Terms.
        </p>

        <h3 className="text-xl mt-6">12. Governing Law</h3>
        <p className="mt-2">
          These Terms shall be governed by and construed in accordance with the laws of the jurisdiction in which our company is established, without
          regard to conflict of law provisions.
        </p>

        <h3 className="text-xl mt-6">13. Contact Information</h3>
        <p className="mt-2">If you have any questions, concerns, or complaints about these Terms, please contact us at:</p>
        <p className="mt-2">
          <span className="font-semibold">Email:</span> hello@inyter.com
        </p>

        <p className="mt-6">By using Kidster, you acknowledge that you have read, understood, and agreed to be bound by these Terms of Use.</p>
      </NCard>
    </div>
  );
};

export default TermsOfUse;
